/**
 * General formatting utilities shared across features.
 */

/** Formats a date string as dd/mm/yyyy — consistent across all tables and lists. */
export const formatDate = (dateStr: string): string => {
  const d = new Date(dateStr);
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear();
  return `${dd}/${mm}/${yyyy}`;
};
